/**
 * Actually not used still. Trying to figure out how to import service in service in angular 2
 */

import { Injectable } from '@angular/core';

@Injectable()
export class ErrorHandlerService {
  dummyHandler(error: any): Promise<any> {
    console.error('An error occurred ', error);

    return Promise.reject(error.message || error);
  }
}
